import { FootnoteAnnotation } from '@time-line/components/common';
import type { PageFootnote } from 'hooks/usePageFootnotes';
import { usePageFootnotes } from 'hooks/usePageFootnotes';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

interface PageFootnoteLinkProps {
  pageFootnotes: PageFootnote[];
  children: ReactNode;
}

export const PageFootnoteLink = ({
  pageFootnotes,
  children,
}: PageFootnoteLinkProps) => {
  const registerFootnote = usePageFootnotes((state) => state.registerFootnote);
  const footnotes = usePageFootnotes(useShallow((state) => state.footnotes));

  useEffect(() => {
    if (pageFootnotes) {
      pageFootnotes.forEach((pageFootnote) => {
        registerFootnote(pageFootnote);
      });
    }
  }, [pageFootnotes, registerFootnote]);

  const indices = pageFootnotes?.reduce<number[]>((acc, curr) => {
    const { index } = footnotes.get(curr.name) || {
      index: -1,
    };
    return [...acc, index];
  }, []);

  return pageFootnotes && pageFootnotes.length > 0 && !indices.includes(-1) ? (
    <FootnoteAnnotation indices={indices} hasBrackets={false} isAnchor={false}>
      {children}
    </FootnoteAnnotation>
  ) : (
    <>{children}</>
  );
};
